import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/labels/page', data, {
    trim: true
  })
}
// 查询所有
export function findAll (data) {
  return request.post('/business/labels/findAll', data)
}
// 创建
export function create (data) {
  return request.post('/business/labels/create', data)
}

// 修改
export function updateById (data) {
  return request.post('/business/labels/updateById', data)
}
// 修改
export function updateStatusById (data) {
  return request.post('/business/labels/updateStatusById', data)
}

// 删除
export function deleteById (id) {
  return request.get(`/business/labels/delete/${id}`)
}

// 批量删除
export function deleteByIdInBatch (ids) {
  return request.get('/business/labels/delete/batch', {
    params: {
      ids
    }
  })
}
